import type { SubComponentsReturnType } from '../../types';

import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import type { InstagramPostComponentsProps } from './types';

export function useInstagramPostComponents(props: InstagramPostComponentsProps): SubComponentsReturnType {
	return {
		header: <Header {...props} />,
		body: <Body {...props} />,
		footer: <Footer {...props} />,
	};
}
